// Common
import { ReactElement, useState, useEffect, useCallback, useReducer } from 'react'
import { useHistory } from 'react-router-dom'

// Components
import Row from 'shared-components/row'
import Col from 'shared-components/col'
import Input from 'shared-components/input'
import Buttons from 'components/common/Buttons'
import Errors from '../common/Errors'

// Reducer
import locationReducer from '../reducers/location'

// Variables
import { validSpace } from '../../variables'

type IProps = {
	goBack: () => void,
}

type Empty = Record<string, never>

export default function Location(props: IProps): ReactElement {
	const [error, setError] = useState('')
	const [data, setData] = useState({
		address: '',
		country: '',
		state: '',
		city: '',
		zip: '',
	})
	const [disable, setDisable] = useState(false)
	const [state, dispatch] = useReducer(locationReducer, {
		country: data.country, address: data.address, state: data.state, city: data.city, zip: data.zip,
	})
	const history = useHistory()

	useEffect(() => {
		dispatch({type:'country', country: data.country })
		dispatch({type:'address', address: data.address})
		dispatch({type:'state', state: data.state})
		dispatch({type:'city', city: data.city})
		dispatch({type:'zip', zip: data.zip})
	}, [dispatch, data])

	const validate = useCallback(value => {
		if (!value || !validSpace.test(value) || value === undefined){
			return false
		}else{
			setError('')
			setDisable(false)
			return true
		}
	}, [])

	useEffect(() => {
		const getLocation = JSON.parse(sessionStorage.getItem('location') || '{}')
		if(getLocation !== {}){
			setData({
				address: getLocation.address,
				country: getLocation.country,
				state: getLocation.state,
				city: getLocation.city,
				zip: getLocation.zip,
			})
		}
		if (!validate(getLocation.address)||
				!validate(getLocation.country)||
				!validate(getLocation.state)||
				!validate(getLocation.city)||
				!validate(getLocation.zip)){
			setError('')
			setDisable(false)
		}
	}, [state.address, state.city, state.country, state.zip, state.state])

	useEffect(() => {
		sessionStorage.setItem('location', JSON.stringify(data))
	}, [data])

	const handleInputChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
		setData({
			...data,
			[event.target.name]: event.target.value,
		})
		sessionStorage.setItem('location', JSON.stringify(data))
	}, [data])

	// const token = '5uTSs6kSLFA6SYnBOvEGsJBIcdqW29KT'
	const token = process.env.TOKEN
	const info = JSON.parse(sessionStorage.getItem('info') || '{}')
	const consent = JSON.parse(sessionStorage.getItem('consent') || '{}')
	const location = JSON.parse(sessionStorage.getItem('location') || '{}')
	const qa = JSON.parse(sessionStorage.getItem('qa') || '{}')

	const onClick = useCallback(() => {
		const getLocation = JSON.parse(sessionStorage.getItem('location') || '{}')
		function isEmpty(obj: Empty) {
			return Object.keys(obj).length === 0
		}
		if (!validate(getLocation.address)||
				!validate(getLocation.country)||
				!validate(getLocation.state)||
				!validate(getLocation.city)||
				!validate(getLocation.zip)){
			setError('Fields should not be empty')
			setDisable(true)
		}else{
			if(isEmpty(qa) !== false){
				setError('You have not completed the questions')
				setDisable(true)
			}else{
				setError('')
				setDisable(false)
				fetch(`${process.env.REACT_APP_API_URL}/summaries`, {
					method: 'POST',
					headers: {
						Authorization: 'Bearer ' + token,
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						name: info.name,
						surname: info.surname,
						email: info.email,
						phone: info.phone,
						consent: consent,
						location,
						qa,
					}),
				})
				history.push('/done')
			}
		}
	}, [state.address, state.city, state.country, state.zip, state.state])

	return (
		<>
			{error && <Errors error={error} />}
			<Col>
				<>
					<Input
						label="Address"
						placeholder="Enter address"
						onChange={handleInputChange}
						name='address'
						value={data.address}
					/>
					<Row style={{margin: '10px 0'}}>
						<Col>
							<Input
								label="Country"
								placeholder="Select a country"
								onChange={handleInputChange}
								name='country'
								value={data.country}
							/>
						</Col>
						<Col>
							<Input
								label="State/Province"
								placeholder="Select a state/province"
								onChange={handleInputChange}
								name='state'
								value={data.state}
							/>
						</Col>
					</Row>
					<Row style={{margin: '10px 0'}}>
						<Col>
							<Input
								label="City"
								placeholder="Select a city"
								onChange={handleInputChange}
								name='city'
								value={data.city}
							/>
						</Col>
						<Col>
							<Input
								label="ZIP Code"
								placeholder="Enter ZIP Code"
								onChange={handleInputChange}
								name='zip'
								value={data.zip}
							/>
						</Col>
					</Row>
				</>
			</Col>
			<Buttons
				goBack={props.goBack}
				goNext={onClick}
				disable={disable}
			/>
		</>
	)
}
